import { render, staticRenderFns } from "./add-tags.vue?vue&type=template&id=7821d853&scoped=true"
import script from "./add-tags.vue?vue&type=script&lang=js"
export * from "./add-tags.vue?vue&type=script&lang=js"
import style0 from "./add-tags.vue?vue&type=style&index=0&id=7821d853&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7821d853",
  null
  
)

export default component.exports